<div class="panel">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      <!-- The list heading is the button that opens its menu (TW-PANEL-07): named by its text, Enter and Space native. -->
      <button
        type="button"
        class="bg-transparent border-0 p-0 [font:inherit] text-inherit text-left cursor-pointer"
        appDPNotesContextMenu
        (appDPContextMenuOpened)="contextMenuOpened = $event"
        (appDPContextMenuFilterChanged)="selectFilter($event)"
        aria-haspopup="menu"
        [attr.aria-expanded]="!!contextMenuOpened"
      >
        <app-dropdown-label [collapsed]="!contextMenuOpened">
          {{ selectedFilter | titleByNotesFilter }}
        </app-dropdown-label>
      </button>

      <div class="grow"></div>

      @if (selectedTab !== 'notebooks') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appNotesListContextMenu
          [appNotesListContextMenuWithAdvancedSearch]="true"
          />
      }
      @if (selectedTab === 'notebooks') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appNotebooksListContextMenu
          [appNotebooksListContextMenuWithAdvancedSearch]="true"
          />
      }

      <app-search-state-indicator
        [applied]="isSearchApplied()"
        (clear)="clearSearch()"
      >
        <app-icon
          class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
          name="search-small"
          stchPopover
          stchPopoverPlacement="bottomRight"
          stchPopoverTrigger="click"
          [stchPopoverContent]="searchPopover"
          [stchPopoverFallbackPlacements]="[]"
          [stchPopoverShowUntil]="popoverClose"
        />
      </app-search-state-indicator>
    </div>
    @if (listState === 'tabs') {
      <app-tabs
        class="panel-heading-tabs"
        [values]="tabs"
        [(value)]="selectedTab"
        />
    }
  </div>

  @if (selectedTab === 'notes' && creationAllowed()) {
    <app-quick-form
      class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter"
      placeholder="Add New Note"
      >
      <app-note-quick-form
        [showMore]="true"
        [destinationTenantId]="notesTenantScope?.effectiveTenantId() ?? undefined"
        (more)="handleNewNote($event)"
        />
      </app-quick-form>
    }

    @if (selectedTab === 'notebooks' && creationAllowed()) {
      <app-quick-form
        class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter"
        placeholder="Add New Notebook"
        >
        <app-notebook-quick-form [showMore]="true" (more)="handleNewNotebook($event)" />
        </app-quick-form>
      }

      <div class="panel-list border-t border-gray-200">
        @if (selectedTab !== 'notebooks') {
          <app-notes-list
            [filters]="notesFilters"
            [showLocationBadge]="isAdvancedSearchApplied()"
            (openNote)="openNote($event)"
            (doubleClickNote)="openNote($event)"
            />
        }

        @if (selectedTab === 'notebooks') {
          <app-notebooks-list
            [filters]="notebooksFilters"
            (openNote)="openNoteInModal($event)"
            (openNotebook)="openNotebook($event)"
            (doubleClickNotebook)="openNotebook($event)"
            />
        }
      </div>
    </div>

<ng-template #searchPopover>
  <app-notes-search-popover
    [width]="600"
    (onSearch)="handleSearch()"
    (onCancel)="handleCancel()"
  />
</ng-template>
